export default __webpack_public_path__ + "static/media/qr-code.bff5d1c2.png";